import { render } from "./Landing.vue?vue&type=template&id=3e613e98"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=3e613e98&lang=css"
script.render = render

export default script